// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__21E35","overflowing":"ReadFullNote_overflowing__1xVmw"};